const PROJECT_NAME = 'PricingWeb';

export default PROJECT_NAME;
